export { default } from "@features/investments/screens/glossary-screen";
